"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3023],{

/***/ "./node_modules/@chakra-ui/popover/dist/index.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J2": function() { return /* binding */ Popover; },
  "QH": function() { return /* binding */ PopoverArrow; },
  "b": function() { return /* binding */ PopoverBody; },
  "us": function() { return /* binding */ PopoverCloseButton; },
  "yk": function() { return /* binding */ PopoverContent; },
  "DT": function() { return /* binding */ PopoverFooter; },
  "Yt": function() { return /* binding */ PopoverHeader; },
  "xo": function() { return /* binding */ PopoverTrigger; }
});

// UNUSED EXPORTS: PopoverAnchor, usePopover, usePopoverContext, usePopoverStyles

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/styled-system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-context/dist/index.esm.js
var react_context_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react-context/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-animation-state/dist/index.esm.js
var react_use_animation_state_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react-use-animation-state/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-event-listener/dist/index.esm.js
var react_use_event_listener_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react-use-event-listener/dist/index.esm.js");
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-use-focus-on-pointer-down/dist/index.esm.js
// src/index.ts

function isRefObject(val) {
  return "current" in val;
}
var isDom = () => typeof window !== "undefined";
function getPlatform() {
  const agent = navigator.userAgentData;
  return (agent == null ? void 0 : agent.platform) ?? navigator.platform;
}
var vn = (v) => isDom() && v.test(navigator.vendor);
var pt = (v) => isDom() && v.test(getPlatform());
var isApple = () => pt(/mac|iphone|ipad|ipod/i);
var isSafari = () => isApple() && vn(/apple/i);
function useFocusOnPointerDown(props) {
  const { ref, elements, enabled } = props;
  const doc = () => {
    var _a;
    return ((_a = ref.current) == null ? void 0 : _a.ownerDocument) ?? document;
  };
  (0,react_use_event_listener_dist_index_esm/* useEventListener */.O)(doc, "pointerdown", (event) => {
    if (!isSafari() || !enabled)
      return;
    const target = event.target;
    const els = elements ?? [ref];
    const isValidTarget = els.some((elementOrRef) => {
      const el = isRefObject(elementOrRef) ? elementOrRef.current : elementOrRef;
      return (el == null ? void 0 : el.contains(target)) || el === target;
    });
    if (doc().activeElement !== target && isValidTarget) {
      event.preventDefault();
      target.focus();
    }
  });
}


// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-focus-effect/dist/index.esm.js
var react_use_focus_effect_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react-use-focus-effect/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-disclosure/dist/index.esm.js
var react_use_disclosure_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react-use-disclosure/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/popper/dist/index.esm.js + 52 modules
var popper_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/popper/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.esm.js
var react_use_merge_refs_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react-use-merge-refs/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/lazy-utils/dist/index.esm.js
var lazy_utils_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/lazy-utils/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/close-button/dist/index.esm.js
var close_button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/close-button/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 168 modules
var motion = __webpack_require__("./node_modules/framer-motion/dist/es/render/dom/motion.mjs");
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/popover/dist/index.esm.js
// ../../../react-shim.js


// src/popover.tsx


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var isFunction = (value) => typeof value === "function";
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}

// src/popover-context.ts

var [PopoverProvider, usePopoverContext] = (0,react_context_dist_index_esm/* createContext */.k)({
  name: "PopoverContext",
  errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});
var [PopoverStylesProvider, usePopoverStyles] = (0,react_context_dist_index_esm/* createContext */.k)({
  name: `PopoverStylesContext`,
  errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
});

// src/use-popover.ts








var TRIGGER = {
  click: "click",
  hover: "hover"
};
function usePopover(props = {}) {
  const {
    closeOnBlur = true,
    closeOnEsc = true,
    initialFocusRef,
    id,
    returnFocusOnClose = true,
    autoFocus = true,
    arrowSize,
    arrowShadowColor,
    trigger = TRIGGER.click,
    openDelay = 200,
    closeDelay = 200,
    isLazy,
    lazyBehavior = "unmount",
    computePositionOnMount,
    ...popperProps
  } = props;
  const { isOpen, onClose, onOpen, onToggle } = (0,react_use_disclosure_dist_index_esm/* useDisclosure */.q)(props);
  const anchorRef = (0,react.useRef)(null);
  const triggerRef = (0,react.useRef)(null);
  const popoverRef = (0,react.useRef)(null);
  const isHoveringRef = (0,react.useRef)(false);
  const hasBeenOpened = (0,react.useRef)(false);
  if (isOpen) {
    hasBeenOpened.current = true;
  }
  const [hasHeader, setHasHeader] = (0,react.useState)(false);
  const [hasBody, setHasBody] = (0,react.useState)(false);
  const uuid = (0,react.useId)();
  const uid = id ?? uuid;
  const [triggerId, popoverId, headerId, bodyId] = [
    "popover-trigger",
    "popover-content",
    "popover-header",
    "popover-body"
  ].map((id2) => `${id2}-${uid}`);
  const {
    referenceRef,
    getArrowProps,
    getPopperProps,
    getArrowInnerProps,
    forceUpdate
  } = (0,popper_dist_index_esm/* usePopper */.D)({
    ...popperProps,
    enabled: isOpen || !!computePositionOnMount
  });
  const animated = (0,react_use_animation_state_dist_index_esm/* useAnimationState */.h)({ isOpen, ref: popoverRef });
  useFocusOnPointerDown({
    enabled: isOpen,
    ref: triggerRef
  });
  (0,react_use_focus_effect_dist_index_esm/* useFocusOnHide */.C)(popoverRef, {
    focusRef: triggerRef,
    visible: isOpen,
    shouldFocus: returnFocusOnClose && trigger === TRIGGER.click
  });
  (0,react_use_focus_effect_dist_index_esm/* useFocusOnShow */.G)(popoverRef, {
    focusRef: initialFocusRef,
    visible: isOpen,
    shouldFocus: autoFocus && trigger === TRIGGER.click
  });
  const shouldRenderChildren = (0,lazy_utils_dist_index_esm/* lazyDisclosure */.k)({
    wasSelected: hasBeenOpened.current,
    enabled: isLazy,
    mode: lazyBehavior,
    isSelected: animated.present
  });
  const getPopoverProps = (0,react.useCallback)((props2 = {}, _ref = null) => {
    const popoverProps = {
      ...props2,
      style: {
        ...props2.style,
        transformOrigin: popper_dist_index_esm/* popperCSSVars.transformOrigin.varRef */.j.transformOrigin.varRef,
        [popper_dist_index_esm/* popperCSSVars.arrowSize.var */.j.arrowSize["var"]]: arrowSize ? `${arrowSize}px` : void 0,
        [popper_dist_index_esm/* popperCSSVars.arrowShadowColor.var */.j.arrowShadowColor["var"]]: arrowShadowColor
      },
      ref: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(popoverRef, _ref),
      children: shouldRenderChildren ? props2.children : null,
      id: popoverId,
      tabIndex: -1,
      role: "dialog",
      onKeyDown: callAllHandlers(props2.onKeyDown, (event) => {
        if (closeOnEsc && event.key === "Escape") {
          onClose();
        }
      }),
      onBlur: callAllHandlers(props2.onBlur, (event) => {
        const relatedTarget = getRelatedTarget(event);
        const targetIsPopover = contains(popoverRef.current, relatedTarget);
        const targetIsTrigger = contains(triggerRef.current, relatedTarget);
        const isValidBlur = !targetIsPopover && !targetIsTrigger;
        if (isOpen && closeOnBlur && isValidBlur) {
          onClose();
        }
      }),
      "aria-labelledby": hasHeader ? headerId : void 0,
      "aria-describedby": hasBody ? bodyId : void 0
    };
    if (trigger === TRIGGER.hover) {
      popoverProps.role = "tooltip";
      popoverProps.onMouseEnter = callAllHandlers(props2.onMouseEnter, () => {
        isHoveringRef.current = true;
      });
      popoverProps.onMouseLeave = callAllHandlers(props2.onMouseLeave, (event) => {
        if (event.nativeEvent.relatedTarget === null) {
          return;
        }
        isHoveringRef.current = false;
        setTimeout(() => onClose(), closeDelay);
      });
    }
    return popoverProps;
  }, [
    shouldRenderChildren,
    popoverId,
    hasHeader,
    headerId,
    hasBody,
    bodyId,
    trigger,
    closeOnEsc,
    onClose,
    isOpen,
    closeOnBlur,
    closeDelay,
    arrowShadowColor,
    arrowSize
  ]);
  const getPopoverPositionerProps = (0,react.useCallback)((props2 = {}, forwardedRef = null) => getPopperProps({
    ...props2,
    style: {
      visibility: isOpen ? "visible" : "hidden",
      ...props2.style
    }
  }, forwardedRef), [isOpen, getPopperProps]);
  const getAnchorProps = (0,react.useCallback)((props2, _ref = null) => {
    return {
      ...props2,
      ref: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(_ref, anchorRef, referenceRef)
    };
  }, [anchorRef, referenceRef]);
  const openTimeout = (0,react.useRef)();
  const closeTimeout = (0,react.useRef)();
  const maybeReferenceRef = (0,react.useCallback)((node) => {
    if (anchorRef.current == null) {
      referenceRef(node);
    }
  }, [referenceRef]);
  const getTriggerProps = (0,react.useCallback)((props2 = {}, _ref = null) => {
    const triggerProps = {
      ...props2,
      ref: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(triggerRef, _ref, maybeReferenceRef),
      id: triggerId,
      "aria-haspopup": "dialog",
      "aria-expanded": isOpen,
      "aria-controls": popoverId
    };
    if (trigger === TRIGGER.click) {
      triggerProps.onClick = callAllHandlers(props2.onClick, onToggle);
    }
    if (trigger === TRIGGER.hover) {
      triggerProps.onFocus = callAllHandlers(props2.onFocus, () => {
        if (openTimeout.current === void 0) {
          onOpen();
        }
      });
      triggerProps.onBlur = callAllHandlers(props2.onBlur, (event) => {
        const relatedTarget = getRelatedTarget(event);
        const isValidBlur = !contains(popoverRef.current, relatedTarget);
        if (isOpen && closeOnBlur && isValidBlur) {
          onClose();
        }
      });
      triggerProps.onKeyDown = callAllHandlers(props2.onKeyDown, (event) => {
        if (event.key === "Escape") {
          onClose();
        }
      });
      triggerProps.onMouseEnter = callAllHandlers(props2.onMouseEnter, () => {
        isHoveringRef.current = true;
        openTimeout.current = window.setTimeout(() => onOpen(), openDelay);
      });
      triggerProps.onMouseLeave = callAllHandlers(props2.onMouseLeave, () => {
        isHoveringRef.current = false;
        if (openTimeout.current) {
          clearTimeout(openTimeout.current);
          openTimeout.current = void 0;
        }
        closeTimeout.current = window.setTimeout(() => {
          if (isHoveringRef.current === false) {
            onClose();
          }
        }, closeDelay);
      });
    }
    return triggerProps;
  }, [
    triggerId,
    isOpen,
    popoverId,
    trigger,
    maybeReferenceRef,
    onToggle,
    onOpen,
    closeOnBlur,
    onClose,
    openDelay,
    closeDelay
  ]);
  (0,react.useEffect)(() => {
    return () => {
      if (openTimeout.current) {
        clearTimeout(openTimeout.current);
      }
      if (closeTimeout.current) {
        clearTimeout(closeTimeout.current);
      }
    };
  }, []);
  const getHeaderProps = (0,react.useCallback)((props2 = {}, ref = null) => ({
    ...props2,
    id: headerId,
    ref: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(ref, (node) => {
      setHasHeader(!!node);
    })
  }), [headerId]);
  const getBodyProps = (0,react.useCallback)((props2 = {}, ref = null) => ({
    ...props2,
    id: bodyId,
    ref: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(ref, (node) => {
      setHasBody(!!node);
    })
  }), [bodyId]);
  return {
    forceUpdate,
    isOpen,
    onAnimationComplete: animated.onComplete,
    onClose,
    getAnchorProps,
    getArrowProps,
    getArrowInnerProps,
    getPopoverPositionerProps,
    getPopoverProps,
    getTriggerProps,
    getHeaderProps,
    getBodyProps
  };
}
function contains(parent, child) {
  return parent === child || (parent == null ? void 0 : parent.contains(child));
}
function getRelatedTarget(event) {
  const activeEl = event.currentTarget.ownerDocument.activeElement;
  return event.relatedTarget ?? activeEl;
}

// src/popover.tsx
function Popover(props) {
  const styles = (0,index_esm/* useMultiStyleConfig */.jC)("Popover", props);
  const { children, ...rest } = (0,dist_index_esm/* omitThemingProps */.Lr)(props);
  const theme = (0,index_esm/* useTheme */.Fg)();
  const context = usePopover({ ...rest, direction: theme.direction });
  return /* @__PURE__ */ react.createElement(PopoverProvider, {
    value: context
  }, /* @__PURE__ */ react.createElement(PopoverStylesProvider, {
    value: styles
  }, runIfFn(children, {
    isOpen: context.isOpen,
    onClose: context.onClose,
    forceUpdate: context.forceUpdate
  })));
}
Popover.displayName = "Popover";

// src/popover-anchor.tsx

function PopoverAnchor(props) {
  const child = react.Children.only(props.children);
  const { getAnchorProps } = usePopoverContext();
  return (0,react.cloneElement)(child, getAnchorProps(child.props, child.ref));
}
PopoverAnchor.displayName = "PopoverAnchor";

// src/popover-arrow.tsx

function PopoverArrow(props) {
  const { bg, bgColor, backgroundColor } = props;
  const { getArrowProps, getArrowInnerProps } = usePopoverContext();
  const styles = usePopoverStyles();
  const arrowBg = bg ?? bgColor ?? backgroundColor;
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ...getArrowProps(),
    className: "chakra-popover__arrow-positioner"
  }, /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    className: cx("chakra-popover__arrow", props.className),
    ...getArrowInnerProps(props),
    __css: {
      ...styles.arrow,
      "--popper-arrow-bg": arrowBg ? `colors.${arrowBg}, ${arrowBg}` : void 0
    }
  }));
}
PopoverArrow.displayName = "PopoverArrow";

// src/popover-body.tsx

var PopoverBody = (0,index_esm/* forwardRef */.Gp)(function PopoverBody2(props, ref) {
  const { getBodyProps } = usePopoverContext();
  const styles = usePopoverStyles();
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ...getBodyProps(props, ref),
    className: cx("chakra-popover__body", props.className),
    __css: styles.body
  });
});
PopoverBody.displayName = "PopoverBody";

// src/popover-close-button.tsx


var PopoverCloseButton = (0,index_esm/* forwardRef */.Gp)(function PopoverCloseButton2(props, ref) {
  const { onClose } = usePopoverContext();
  const styles = usePopoverStyles();
  return /* @__PURE__ */ react.createElement(close_button_dist_index_esm/* CloseButton */.P, {
    size: "sm",
    onClick: onClose,
    className: cx("chakra-popover__close-btn", props.className),
    __css: styles.closeButton,
    ref,
    ...props
  });
});
PopoverCloseButton.displayName = "PopoverCloseButton";

// src/popover-content.tsx


// src/popover-transition.tsx



function mergeVariants(variants) {
  if (!variants)
    return;
  return {
    enter: {
      ...variants.enter,
      visibility: "visible"
    },
    exit: {
      ...variants.exit,
      transitionEnd: {
        visibility: "hidden"
      }
    }
  };
}
var scaleFade = {
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  }
};
var MotionSection = (0,index_esm/* chakra */.m$)(motion/* motion.section */.E.section);
var PopoverTransition = (0,index_esm/* forwardRef */.Gp)(function PopoverTransition2(props, ref) {
  const { variants = scaleFade, ...rest } = props;
  const { isOpen } = usePopoverContext();
  return /* @__PURE__ */ react.createElement(MotionSection, {
    ref,
    variants: mergeVariants(variants),
    initial: false,
    animate: isOpen ? "enter" : "exit",
    ...rest
  });
});
PopoverTransition.displayName = "PopoverTransition";

// src/popover-content.tsx
var PopoverContent = (0,index_esm/* forwardRef */.Gp)(function PopoverContent2(props, ref) {
  const { rootProps, motionProps, ...contentProps } = props;
  const { getPopoverProps, getPopoverPositionerProps, onAnimationComplete } = usePopoverContext();
  const styles = usePopoverStyles();
  const contentStyles = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    ...styles.content
  };
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ...getPopoverPositionerProps(rootProps),
    __css: styles.popper,
    className: "chakra-popover__popper"
  }, /* @__PURE__ */ react.createElement(PopoverTransition, {
    ...motionProps,
    ...getPopoverProps(contentProps, ref),
    onAnimationComplete: callAll(onAnimationComplete, contentProps.onAnimationComplete),
    className: cx("chakra-popover__content", props.className),
    __css: contentStyles
  }));
});
PopoverContent.displayName = "PopoverContent";

// src/popover-footer.tsx

function PopoverFooter(props) {
  const styles = usePopoverStyles();
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.footer */.m$.footer, {
    ...props,
    className: cx("chakra-popover__footer", props.className),
    __css: styles.footer
  });
}
PopoverFooter.displayName = "PopoverFooter";

// src/popover-header.tsx

var PopoverHeader = (0,index_esm/* forwardRef */.Gp)(function PopoverHeader2(props, ref) {
  const { getHeaderProps } = usePopoverContext();
  const styles = usePopoverStyles();
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.header */.m$.header, {
    ...getHeaderProps(props, ref),
    className: cx("chakra-popover__header", props.className),
    __css: styles.header
  });
});
PopoverHeader.displayName = "PopoverHeader";

// src/popover-trigger.tsx

function PopoverTrigger(props) {
  const child = react.Children.only(props.children);
  const { getTriggerProps } = usePopoverContext();
  return (0,react.cloneElement)(child, getTriggerProps(child.props, child.ref));
}
PopoverTrigger.displayName = "PopoverTrigger";



/***/ }),

/***/ "./src/components/Layout/Navbar/NavSearch/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Navbar_NavSearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js + 3 modules
var index_esm = __webpack_require__("./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var system_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/spinner/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js
var avatar_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/avatar/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/input/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js + 1 modules
var chakra_ui_icons_esm = __webpack_require__("./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js");
// EXTERNAL MODULE: ./node_modules/@choc-ui/chakra-autocomplete/dist/chakra-autocomplete.esm.js + 3 modules
var chakra_autocomplete_esm = __webpack_require__("./node_modules/@choc-ui/chakra-autocomplete/dist/chakra-autocomplete.esm.js");
// EXTERNAL MODULE: ./src/services/search/utils.ts
var utils = __webpack_require__("./src/services/search/utils.ts");
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__("./src/config/index.ts");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 6 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./src/env.mjs + 1 modules
var env = __webpack_require__("./src/env.mjs");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
;// CONCATENATED MODULE: ./src/components/SEO/Search.tsx




const SearchSEO = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* SiteLinksSearchBoxJsonLd */.iu, {
        url: env/* env.NEXT_PUBLIC_DOMAIN */.O.NEXT_PUBLIC_DOMAIN || "",
        potentialActions: [
            {
                target: "".concat(env/* env.NEXT_PUBLIC_DOMAIN */.O.NEXT_PUBLIC_DOMAIN, "/search/?q"),
                queryInput: "search_term_string"
            }
        ]
    });
};
/* harmony default export */ var Search = (SearchSEO);

// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/components/WikiImage.tsx
var WikiImage = __webpack_require__("./src/components/WikiImage.tsx");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__("./src/utils/googleAnalytics.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiSummary.ts
var getWikiSummary = __webpack_require__("./src/utils/WikiUtils/getWikiSummary.ts");
;// CONCATENATED MODULE: ./src/components/Layout/Navbar/NavSearch/index.tsx















const ItemPaths = {
    [utils/* SEARCH_TYPES.WIKI */.VS.WIKI]: "/wiki/",
    [utils/* SEARCH_TYPES.CATEGORY */.VS.CATEGORY]: "/categories/",
    [utils/* SEARCH_TYPES.ACCOUNT */.VS.ACCOUNT]: "/account/"
};
const WIKIS_LIMIT = 5;
const CATEGORIES_LIMIT = 2;
const ACCOUNTS_LIMIT = 4;
const NavSearch = (props)=>{
    var ref, ref1, ref2;
    const { inputGroupProps , inputProps , listProps , setHamburger  } = props;
    const { query , setQuery , isLoading , results  } = (0,utils/* useNavSearch */.V0)();
    const router = (0,next_router.useRouter)();
    const unrenderedWikis = results.wikis.length - WIKIS_LIMIT;
    const unrenderedCategories = results.categories.length - CATEGORIES_LIMIT;
    const unrenderedAccounts = results.accounts.length - ACCOUNTS_LIMIT;
    const noResults = results.wikis.length === 0 && results.categories.length === 0 && results.accounts.length === 0;
    const resolvedUnrenderedWikis = unrenderedWikis > 0 ? unrenderedWikis : 0;
    const resolvedUnrenderedCategories = unrenderedCategories > 0 ? unrenderedCategories : 0;
    const resolvedUnrenderedAccounts = unrenderedAccounts > 0 ? unrenderedAccounts : 0;
    const totalUnrendered = resolvedUnrenderedWikis + resolvedUnrenderedCategories + resolvedUnrenderedAccounts;
    const inputRef = (0,react.useRef)(null);
    (0,index_esm/* useEventListener */.OR)("keydown", (event)=>{
        const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator === null || navigator === void 0 ? void 0 : navigator.userAgent);
        const hotkey = isMac ? "metaKey" : "ctrlKey";
        const el = event.target;
        const interactiveElementIsFocused = (el === null || el === void 0 ? void 0 : el.closest('input, [contenteditable=true], [role="dialog"]')) !== null;
        if ((event.key && event.key.toLowerCase() === "k" && event[hotkey] || event.key === "/") && !interactiveElementIsFocused) {
            var ref;
            event.preventDefault();
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    });
    const emptyState = /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        direction: "column",
        gap: "6",
        align: "center",
        justify: "center",
        py: "16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                fontWeight: "semibold",
                children: "No search Results"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* LinkButton */.Qj, {
                variant: "outline",
                px: "10",
                w: "fit-content",
                fontWeight: "semibold",
                fontSize: "xs",
                href: "/create-wiki",
                children: "Create New Wiki"
            })
        ]
    });
    const loadingView = /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
        py: "9",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
            color: "#63B3ED"
        })
    });
    const titleStyles = {
        fontWeight: "normal",
        fontSize: "md",
        textTransform: "capitalize",
        borderBottomWidth: 1,
        p: 4,
        m: 0
    };
    const generalItemStyles = {
        m: 0,
        rounded: "none",
        px: 4,
        py: 2,
        gap: "2.5",
        borderBottomWidth: 1,
        _last: {
            borderBottomWidth: 0
        }
    };
    const wikisSearchList = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (ref = results.wikis) === null || ref === void 0 ? void 0 : ref.slice(0, WIKIS_LIMIT).map((wiki)=>{
            var ref, ref1;
            const wikiImage = "".concat(config/* default.pinataBaseUrl */.Z.pinataBaseUrl).concat((ref = wiki.images) === null || ref === void 0 ? void 0 : ref[0].id);
            const value = (0,utils/* fillType */.QN)(wiki, utils/* SEARCH_TYPES.WIKI */.VS.WIKI);
            // This negates the bug that is caused by two wikis with the same title.
            // value.title = `${article.title}${article.id}`
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_autocomplete_esm/* AutoCompleteItem */.Gb, {
                value: value,
                getValue: (art)=>art.title,
                label: wiki.title,
                onClick: ()=>setHamburger(false),
                ...generalItemStyles,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiImage/* WikiImage */.R, {
                        src: wikiImage,
                        alt: wiki.title,
                        imgBoxSize: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag * 40,
                        flexShrink: 0,
                        borderRadius: 5,
                        overflow: "hidden"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                        direction: "column",
                        w: {
                            lg: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                                fontWeight: "semibold",
                                fontSize: "sm",
                                children: wiki.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                noOfLines: {
                                    base: 2,
                                    lg: 1
                                },
                                maxW: "full",
                                fontSize: "xs",
                                children: (0,getWikiSummary/* getWikiSummary */.L)(wiki, getWikiSummary/* WikiSummarySize.Huge */.D.Huge)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Wrap */.Eq, {
                        w: "full",
                        justify: "end",
                        gap: "1",
                        ml: "auto",
                        maxWidth: "fit-content",
                        display: wiki.tags.length > 0 ? "flex" : "none",
                        children: (ref1 = wiki.tags) === null || ref1 === void 0 ? void 0 : ref1.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.div */.m$.div, {
                                fontWeight: "medium",
                                fontSize: "xs",
                                alignSelf: "center",
                                px: "2",
                                borderBottomWidth: 1,
                                bg: "gray.100",
                                rounded: "md",
                                _dark: {
                                    bg: "gray.800"
                                },
                                ml: "auto",
                                children: tag.id
                            }, "".concat(wiki.id, "-").concat(tag.id)))
                    })
                ]
            }, wiki.id);
        })
    });
    const accountsSearchList = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (ref1 = results.accounts) === null || ref1 === void 0 ? void 0 : ref1.slice(0, ACCOUNTS_LIMIT).map((account)=>{
            const value = (0,utils/* fillType */.QN)(account, utils/* SEARCH_TYPES.ACCOUNT */.VS.ACCOUNT);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_autocomplete_esm/* AutoCompleteItem */.Gb, {
                value: value,
                getValue: (acc)=>acc.username,
                label: account.bio,
                onClick: ()=>setHamburger(false),
                ...generalItemStyles,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                        alt: account.username,
                        address: account.id,
                        avatarIPFS: account.avatar
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                                fontWeight: "semibold",
                                fontSize: "sm",
                                children: account.username
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                noOfLines: 1,
                                maxW: "full",
                                fontSize: "xs",
                                children: account.bio
                            })
                        ]
                    })
                ]
            }, account.id);
        })
    });
    const categoriesSearchList = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (ref2 = results.categories) === null || ref2 === void 0 ? void 0 : ref2.slice(0, CATEGORIES_LIMIT).map((category)=>{
            const value = (0,utils/* fillType */.QN)(category, utils/* SEARCH_TYPES.CATEGORY */.VS.CATEGORY);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_autocomplete_esm/* AutoCompleteItem */.Gb, {
                value: value,
                getValue: (art)=>art.title,
                label: category.title,
                onClick: ()=>setHamburger(false),
                ...generalItemStyles,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                        src: category.cardImage,
                        name: category.title,
                        size: "xs"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                        fontWeight: "semibold",
                        fontSize: "sm",
                        children: category.title
                    })
                ]
            }, category.id);
        })
    });
    const searchList = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_autocomplete_esm/* AutoCompleteGroup */.f5, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_autocomplete_esm/* AutoCompleteGroupTitle */.TQ, {
                        ...titleStyles,
                        children: "Wikis"
                    }),
                    wikisSearchList
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_autocomplete_esm/* AutoCompleteGroup */.f5, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_autocomplete_esm/* AutoCompleteGroupTitle */.TQ, {
                        ...titleStyles,
                        children: "Categories"
                    }),
                    categoriesSearchList
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_autocomplete_esm/* AutoCompleteGroup */.f5, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_autocomplete_esm/* AutoCompleteGroupTitle */.TQ, {
                        ...titleStyles,
                        children: "Accounts"
                    }),
                    accountsSearchList
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_autocomplete_esm/* AutoComplete */.Qc, {
                closeOnSelect: false,
                disableFilter: true,
                suggestWhenEmpty: true,
                emptyState: !isLoading && noResults && emptyState,
                shouldRenderSuggestions: (q)=>q.length >= 3,
                openOnFocus: query.length >= 3,
                onSelectOption: (option)=>{
                    const { id , type  } = option.item.originalValue;
                    router.push(ItemPaths[type] + id);
                    (0,googleAnalytics/* logEvent */.K)({
                        action: "CLICK_BY_SEARCH",
                        label: ItemPaths[type] + id,
                        value: 1,
                        category: "search_tags"
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputGroup */.BZ, {
                        size: "lg",
                        maxW: "800px",
                        display: {
                            base: "none",
                            md: "block"
                        },
                        ...inputGroupProps,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* InputLeftElement */.Z8, {
                                ml: {
                                    base: "15px",
                                    xl: "unset"
                                },
                                pointerEvents: "none",
                                h: "full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* Search2Icon */.GV, {
                                    color: "gray.300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_autocomplete_esm/* AutoCompleteInput */.Vp, {
                                ml: {
                                    base: "15px",
                                    xl: "unset"
                                },
                                value: query,
                                onChange: (e)=>setQuery(e.target.value),
                                placeholder: "Search wikis, categories, tags and users",
                                _placeholderShown: {
                                    textOverflow: "ellipsis"
                                },
                                fontSize: "16",
                                ref: inputRef,
                                borderColor: "rankingListBorder",
                                ...inputProps
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_autocomplete_esm/* AutoCompleteList */.Jm, {
                        mx: {
                            base: "15px",
                            xl: "unset"
                        },
                        p: "0",
                        maxH: "auto",
                        shadow: "lg",
                        ...listProps,
                        children: [
                            isLoading ? loadingView : searchList,
                            totalUnrendered > 0 && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
                                _dark: {
                                    color: "whiteAlpha.600"
                                },
                                py: "5",
                                justify: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Elements/* LinkButton */.Qj, {
                                    href: "/search/".concat(encodeURIComponent(query)),
                                    variant: "outline",
                                    onClick: ()=>setHamburger(false),
                                    children: [
                                        "+View ",
                                        totalUnrendered,
                                        " more Results"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Navbar_NavSearch = (NavSearch);


/***/ }),

/***/ "./src/components/WikiImage.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ WikiImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/Image/Image.tsx");



const PLACEHOLDER_IMAGE = "/images/defaults/broken-image.png";
const shimmer = (w, h)=>'\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#F9D1F4" offset="20%" />\n      <stop stop-color="#F399E8" offset="50%" />\n      <stop stop-color="#F9D1F4" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#F9D1F4" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
const toBase64 = (str)=> false ? 0 : window.btoa(str);
const WikiImage = (param)=>{
    let { imageURL , ...rest } = param;
    const [src, setSrc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(imageURL || PLACEHOLDER_IMAGE);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setSrc(imageURL || PLACEHOLDER_IMAGE);
    }, [
        imageURL
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, {
        src: src,
        placeholder: "blur",
        onError: ()=>setSrc(PLACEHOLDER_IMAGE),
        blurDataURL: "data:image/svg+xml;base64,".concat(toBase64(shimmer(700, 475))),
        ...rest
    });
};


/***/ }),

/***/ "./src/services/search/utils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QN": function() { return /* binding */ fillType; },
/* harmony export */   "V0": function() { return /* binding */ useNavSearch; },
/* harmony export */   "VS": function() { return /* binding */ SEARCH_TYPES; },
/* harmony export */   "bS": function() { return /* binding */ fetchCategoriesList; },
/* harmony export */   "vK": function() { return /* binding */ fetchWikisList; }
/* harmony export */ });
/* unused harmony export fetchAccountsList */
/* harmony import */ var _services_search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/services/search/index.ts");
/* harmony import */ var _services_wikis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/services/wikis/index.ts");
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/debounce/index.js");
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(debounce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/googleAnalytics.ts");






const SEARCH_TYPES = {
    WIKI: "WIKI",
    CATEGORY: "CATEGORY",
    ACCOUNT: "ACCOUNT"
};
const fillType = (item, type)=>{
    return {
        ...item,
        type
    };
};
const fetchWikisList = async (query)=>{
    const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch(_services_search__WEBPACK_IMPORTED_MODULE_0__/* .getWikisByTitle.initiate */ .y9.initiate(query));
    const { data: tagsData  } = await _store_store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch(_services_wikis__WEBPACK_IMPORTED_MODULE_1__/* .getTagWikis.initiate */ .Ad.initiate({
        id: query
    }));
    return [
        ...data || [],
        ...tagsData || []
    ];
};
const fetchCategoriesList = async (query)=>{
    const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch(_services_search__WEBPACK_IMPORTED_MODULE_0__/* .getCategoriesByTitle.initiate */ .W5.initiate(query));
    return data;
};
const fetchAccountsList = async (query)=>{
    const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch(_services_search__WEBPACK_IMPORTED_MODULE_0__/* .getAccountsByTitle.initiate */ .sS.initiate(query));
    return data;
};
const debouncedFetchResults = (0,debounce__WEBPACK_IMPORTED_MODULE_3__.debounce)((query, cb)=>{
    Promise.all([
        fetchWikisList(query),
        fetchCategoriesList(query),
        fetchAccountsList({
            id: query,
            username: query
        })
    ]).then((res)=>{
        const [wikis = [], categories = [], accounts = []] = res;
        cb({
            wikis,
            categories,
            accounts
        });
    });
}, 500);
const useNavSearch = ()=>{
    const [query, setQuery] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [results, setResults] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        wikis: [],
        categories: [],
        accounts: []
    });
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (query && query.length >= 3) {
            setIsLoading(true);
            debouncedFetchResults(query, (res)=>{
                if (!res.accounts && !res.wikis && !res.categories) {
                    (0,_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_5__/* .logEvent */ .K)({
                        action: "SEARCH_NO_RESULTS",
                        label: query,
                        category: "search_tag",
                        value: 1
                    });
                }
                setResults(res);
                setIsLoading(false);
            });
        }
    }, [
        query
    ]);
    return {
        query,
        setQuery,
        isLoading,
        results
    };
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiSummary.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ WikiSummarySize; },
/* harmony export */   "L": function() { return /* binding */ getWikiSummary; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

var WikiSummarySize;
(function(WikiSummarySize) {
    WikiSummarySize[WikiSummarySize["Small"] = 65] = "Small";
    WikiSummarySize[WikiSummarySize["Medium"] = 70] = "Medium";
    WikiSummarySize[WikiSummarySize["BIG"] = 110] = "BIG";
    WikiSummarySize[WikiSummarySize["Huge"] = 160] = "Huge";
})(WikiSummarySize || (WikiSummarySize = {}));
const getWikiSummary = function(wiki) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : WikiSummarySize.Huge;
    if (wiki.summary) return (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenText */ .El)(wiki.summary, size);
    return "";
};


/***/ }),

/***/ "./src/utils/textUtils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ slugifyText; },
/* harmony export */   "El": function() { return /* binding */ shortenText; },
/* harmony export */   "TY": function() { return /* binding */ lettersToNum; },
/* harmony export */   "Zw": function() { return /* binding */ isVerifiedContentLinks; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "lK": function() { return /* binding */ shortenBalance; },
/* harmony export */   "p0": function() { return /* binding */ shortenAccount; }
/* harmony export */ });
/* unused harmony export shortenMediaText */
/* harmony import */ var _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@everipedia/iq-utils/build/module/index.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/slugify/slugify.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/humanize-plus/dist/humanize.js");
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humanize_plus__WEBPACK_IMPORTED_MODULE_2__);



const lettersToNum = (str)=>{
    let out = 0;
    const len = str.length;
    for(let pos = 0; pos < len; pos += 1){
        out += (str.charCodeAt(pos) - 64) * 26 ** (len - pos - 1);
    }
    return out;
};
const shortenAccount = function(account) {
    let firstTakeLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, secondTakeLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4;
    const firstChunk = account.substring(0, firstTakeLength);
    const secondChunk = account.substring(account.length - secondTakeLength);
    return "".concat(firstChunk, "...").concat(secondChunk);
};
const shortenBalance = (balance)=>typeof balance === "number" ? humanize_plus__WEBPACK_IMPORTED_MODULE_2__.formatNumber(balance, 2) : balance;
const shortenText = (text, length)=>{
    return (text === null || text === void 0 ? void 0 : text.length) > length ? "".concat(text.substring(0, length), "...") : text;
};
const shortenMediaText = (name)=>{
    const nameArray = name.split(".");
    return nameArray[0].length > 6 ? "".concat(nameArray[0].substring(0, 6), "....").concat(nameArray[1]) : name;
};
const slugifyText = (text)=>{
    return slugify__WEBPACK_IMPORTED_MODULE_1___default()(text.toLowerCase(), {
        strict: true,
        lower: true,
        remove: /[*+~.()'"!:@]/g
    });
};
const isValidUrl = (urlString)=>{
    try {
        return Boolean(new URL(urlString));
    } catch (_e) {
        return false;
    }
};
const isVerifiedContentLinks = (content)=>{
    const markdownLinks = content.match(/\[(.*?)\]\((.*?)\)/g);
    let isValid = true;
    markdownLinks === null || markdownLinks === void 0 ? void 0 : markdownLinks.every((link)=>{
        const linkMatch = link.match(/\[(.*?)\]\((.*?)\)/);
        const text = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[1];
        const url = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[2];
        if (text && url && _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedLinkNames.includes */ .Kp.includes(text) && !isValidUrl(url)) {
            isValid = true;
            return true;
        }
        if (url && url.charAt(0) !== "#") {
            const validURLRecognizer = new RegExp("^https?://(www\\.)?(".concat(_everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedDomains.join */ .xw.join("|"), ")"));
            isValid = validURLRecognizer.test(url);
            return isValid;
        }
        return true;
    });
    return isValid;
};


/***/ })

}]);